import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { TranslateService } from 'src/app/services/translate.service';

declare var jQuery: any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public faqs: {Q: string, A: string}[];

  @ViewChild('faqModal', {static: false}) faqModal: ElementRef;

  constructor(
    private translate: TranslateService
  ) { }

  ngOnInit() {
  }

  faqModalToggle() {
    this.faqs = this.translate.get('FAQ');
    let className = this.faqModal.nativeElement.className;
    className.includes(' in') ? className.replace(' in', '') : className += ' in';
    jQuery('#faq').modal('toggle');
  }
}
